import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordPractitionerModel} from '../../../api/model/medicalRecordPractitioner.model';
import {MedicalRecordPractitionerConverter} from '../../../api/converter/medicalRecordPractitioner.converter';

@Injectable({providedIn: 'root'})
export class MedicalPractitionerDataService
    extends AbstractDataServiceV2<MedicalRecordPractitionerModel, MedicalRecordPractitionerConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordPractitionerConverter) {
        super('MedicalPractitioner', http, httpUrlGenerator, logger, config, converter);
    }
}
